import { apiClient } from "@/lib/api";
import type { LeadPayload, LeadRecord } from "@/types";

/**
 * Lead service — thin, typed wrapper around the leads API.
 *
 * Keeping API shape in a service (rather than inside components/hooks) means
 * a future CRM integration or endpoint change is isolated to this file.
 */
export const leadsService = {
  async submit(payload: LeadPayload): Promise<LeadRecord> {
    const { data } = await apiClient.post<LeadRecord>("/leads", payload);
    return data;
  },
};
